<template>
  <div class="home">
    <keep-alive>
      <router-view />
    </keep-alive>

  </div>
</template>

<script>

export default {
  name: 'Home',
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
